import React from "react";
import { Link } from "react-router-dom";
import ClientHeader from "../../client-header/components/index";
import ClientFooter from "../../client-footer/components/index";
const ClientCareers = () => {
  return (
    <>
      <ClientHeader />
      <main className="overflow-hidden">

        {/* HERO SECTION */}
        <section className="homepad-about py-5" style={{ backgroundColor: "#f4f7f6" }}>
          <div className="container py-lg-5">
            <div className="row align-items-center">
              <div className="col-lg-6 mb-5 mb-lg-0 pe-lg-5">
                <h6 className="text-success font-weight-bold text-uppercase mb-3" style={{ letterSpacing: "2px" }}>
                  Join Our Team
                </h6>
                <h1 className="font-weight-bold montserrat text-primary mb-4" style={{ fontSize: "3.5rem", lineHeight: "1.1" }}>
                  Build a Future <br /> <span className="text-success">With Us.</span>
                </h1>
                <p className="font-size-18 text-muted line-hight-3 mb-4">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. We are looking for passionate individuals to help us empower the next generation.
                </p>
                <a href="#openings" className="btn btn-success btn-lg font-weight-bold px-4 py-3 rounded-3 mt-3">
                  View Open Positions
                </a>
              </div>
              <div className="col-lg-6">
                <img
                  src="/assets/images/about-img.jpg"
                  alt="Careers at JGF"
                  className="w-100 rounded-4 shadow-lg"
                  style={{ objectFit: "cover", height: "400px" }}
                />
              </div>
            </div>
          </div>
        </section>

        {/* WHY WORK WITH US (BENEFITS) */}
        <section className="py-5 my-4">
          <div className="container py-lg-4">
            <div className="text-center mb-5">
              <h2 className="font-weight-bold montserrat text-primary font-size-46 mb-3">Why Work With Us?</h2>
              <div className="mx-auto bg-success" style={{ height: "3px", width: "60px" }}></div>
            </div>

            <div className="row g-4 text-center">
              <div className="col-md-4">
                <div className="card border-0 shadow-sm rounded-4 p-4 h-100">
                  <div className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center mx-auto mb-4" style={{ width: "70px", height: "70px" }}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path></svg>
                  </div>
                  <h4 className="font-weight-bold mb-3 text-primary">Competitive Benefits</h4>
                  <p className="text-muted font-size-15 mb-0">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore.</p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="card border-0 shadow-sm rounded-4 p-4 h-100">
                  <div className="bg-success text-white rounded-circle d-flex align-items-center justify-content-center mx-auto mb-4" style={{ width: "70px", height: "70px" }}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>
                  </div>
                  <h4 className="font-weight-bold mb-3 text-primary">Inclusive Culture</h4>
                  <p className="text-muted font-size-15 mb-0">Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo.</p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="card border-0 shadow-sm rounded-4 p-4 h-100">
                  <div className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center mx-auto mb-4" style={{ width: "70px", height: "70px" }}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline></svg>
                  </div>
                  <h4 className="font-weight-bold mb-3 text-primary">Growth Opportunities</h4>
                  <p className="text-muted font-size-15 mb-0">Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* OPEN POSITIONS */}
        <section id="openings" className="py-5" style={{ backgroundColor: "#f8f9fa" }}>
          <div className="container py-lg-4">
            <div className="row justify-content-center mb-5">
              <div className="col-lg-8 text-center">
                <h2 className="font-weight-bold montserrat text-primary font-size-46 mb-3">Open Positions</h2>
                <p className="text-muted font-size-16">Join our team and make a meaningful impact in your community.</p>
              </div>
            </div>

            <div className="row justify-content-center">
              <div className="col-lg-9">

                {/* Job Item 1 */}
                <div className="card border-0 shadow-sm rounded-4 mb-3 p-4 p-md-4 transition-hover">
                  <div className="row align-items-center">
                    <div className="col-md-8 mb-3 mb-md-0">
                      <h4 className="font-weight-bold text-primary font-size-22 mb-1">Program Coordinator</h4>
                      <p className="text-muted mb-2 font-size-14">
                        <span className="me-3">📍 Hampton Roads, VA</span>
                        <span>⏱ Full-Time</span>
                      </p>
                      <p className="text-muted font-size-15 mb-0">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt.</p>
                    </div>
                    <div className="col-md-4 text-md-end">
                      <Link
                        to="/contact"
                        className="btn btn-outline-success font-weight-bold px-4 rounded-3"
                        style={{ textDecoration: 'none' }} // Ensures no underline on hover
                      >
                        Apply Now
                      </Link>
                    </div>
                  </div>
                </div>

                {/* Job Item 2 */}
                <div className="card border-0 shadow-sm rounded-4 mb-3 p-4 p-md-4 transition-hover">
                  <div className="row align-items-center">
                    <div className="col-md-8 mb-3 mb-md-0">
                      <h4 className="font-weight-bold text-primary font-size-22 mb-1">Community Outreach Specialist</h4>
                      <p className="text-muted mb-2 font-size-14">
                        <span className="me-3">📍 Remote</span>
                        <span>⏱ Part-Time</span>
                      </p>
                      <p className="text-muted font-size-15 mb-0">Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip.</p>
                    </div>
                    <div className="col-md-4 text-md-end">
                      <Link
                        to="/contact"
                        className="btn btn-outline-success font-weight-bold px-4 rounded-3"
                        style={{ textDecoration: 'none' }} // Ensures no underline on hover
                      >
                        Apply Now
                      </Link>
                    </div>
                  </div>
                </div>

                {/* Job Item 3 */}
                <div className="card border-0 shadow-sm rounded-4 p-4 p-md-4 transition-hover">
                  <div className="row align-items-center">
                    <div className="col-md-8 mb-3 mb-md-0">
                      <h4 className="font-weight-bold text-primary font-size-22 mb-1">Development Director</h4>
                      <p className="text-muted mb-2 font-size-14">
                        <span className="me-3">📍 Hampton Roads, VA</span>
                        <span>⏱ Full-Time</span>
                      </p>
                      <p className="text-muted font-size-15 mb-0">Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat.</p>
                    </div>
                    <div className="col-md-4 text-md-end">
                      <Link
                        to="/contact"
                        className="btn btn-outline-success font-weight-bold px-4 rounded-3"
                        style={{ textDecoration: 'none' }} // Ensures no underline on hover
                      >
                        Apply Now
                      </Link>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </section>

      </main>
      <ClientFooter />
    </>
  );
};

export default ClientCareers;